import React, { useEffect, useState } from "react";
import Card from "@material-ui/core/Card";
import { ListItemText, TableCell, TableFooter, TableRow } from "@material-ui/core";
import MaterialTable, { MTableBody } from "material-table";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { observer, inject } from "mobx-react";
import {
  qarSystemsTableOptions,
  qarSystemsColumns,
  isValidDate,
  sendMailsConfirmationModal,
  setManagerReviewsCompletedConfirmationModal,
  qarQuarters,
  qarAccountGroupsColumns
} from "../../helper/constants";
import { LoadingSpinner } from "../LoadingSpinner/LoadingSpinner";
import QarManagers from "../QarManagers/QarManagers";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import "./QarSystems.css";
import { Dropdown } from "semantic-ui-react";
import { exportQarFindingsClickHandler, RenderUsersWithoutRolesTable } from "../Reporting/HelperFunctionsReporting";
import { Tab, Tabs } from '@material-ui/core';
import { Quarter } from 'src/stores/models/enums';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { IconButton } from '@material-ui/core';
import { HtmlTooltip } from '../HtmlTooltip/HtmlTooltip';
import { ModalWrapper } from 'src/components/ModalWrapper';
import { List, ListItem, ListItemButton } from "@mui/material";
import QarAllUnmatchedAccounts from "../QarManagers/QarAllUnmatchedAccounts";
import { qarAdminNavListItems } from "src/helper/enums";
import QarManualData from "./QarManualData";

const QarSystems = inject("RootStore")(
  observer(({ RootStore }) => {
    useEffect(() => {
      async function getManualDataForPreview() {
        await RootStore.qarStore.getManualDataForPreview();
      }

      getManualDataForPreview();

      RootStore.qarStore.getAllDataCenters().catch(console.log);
      RootStore.qarStore.getComplianceReviews();

      if (!RootStore.qarStore.currentComplianceReviewId) {
        RootStore.qarStore.getAllSystemsForReview("00000000-0000-0000-0000-000000000000");
      }
      else {
        RootStore.qarStore.getAllSystemsForReview(RootStore.qarStore.currentComplianceReviewId);
      }

    }, [RootStore.qarStore]);

    const [chameleonAccountGroup, setChameleonAccountGroup] = useState(null);

    const [activeSystemName, setActiveSystemName] = useState(null);

    const [activeItem, setActiveItem] = useState(qarAdminNavListItems.qarSystems);

    const setAccountGroups = (account) => {
      RootStore.qarStore.setAccountGroups(account);
    };

    const getSystemAccounts = (id) => {
      RootStore.qarStore.currentlyReviewedSystemForReview =
        RootStore.qarStore.systemsForReview.filter((s) => s.id === id)[0];
      RootStore.qarStore.currentlyReviewedSystemForReview.accounts.map((x) => {
        if (RootStore.qarStore.systemsForReview.filter((s) => s.id === id)[0].name === 'Chameleon') {
          setAccountGroups(x)
        };
        x.notificationDate =
          RootStore.qarStore.currentlyReviewedSystemForReview.notificationDate;
      });
      setChameleonAccountGroup(null);

      RootStore.qarStore.currentlyReviewedSystemForReview.accounts.forEach((account) => {
        account.accounts = (account.totalReviewedUserAccounts + account.totalReviewedUnmatchedAccounts) + "/" + (account.totalUserAccounts + account.totalUnmatchedAccounts);

        let totalAccounts = account.totalUserAccounts + account.totalUnmatchedAccounts;
        if (totalAccounts === 0) {
          account.completedAccounts = "0 %";
        }
        else {
          let completedAccounts = account.totalReviewedUserAccounts + account.totalReviewedUnmatchedAccounts;
          account.completedAccounts = (completedAccounts / totalAccounts * 100).toFixed(2) + " %";
        }

        account.managers = account.completedManagerReviews + "/" + account.totalManagerReviews;

        let totalManagers = account.totalManagerReviews;
        if (totalManagers === 0) {
          account.completedManagers = "0 %";
        }
        else {
          let completedManagers = account.completedManagerReviews;
          account.completedManagers = (completedManagers / totalManagers * 100).toFixed(2) + " %";
        }

        if (account.notificationDate === "0001-01-01T00:00:00.000Z") {
          account.dueDate = "N/A";
        }
        else {
          account.dueDate = new Date(account.notificationDate).toUTCString();
        }
      });
    };

    const clickHandler = (event, rowData) => {
      RootStore.qarStore.currentlySelectedAccountForReview = rowData;
    };

    const accountGroupsClickHadler = (event, rowData) => {
      setChameleonAccountGroup(rowData);
    }

    const [showModal, setShowModal] = useState(false);
    const [showCompletedReviewsModal, setCompletedReviewsShowModal] = useState(false);
    const [selectedOption, setSelectedOption] = useState("");
    const [selectedYearOption, setSelectedYearOption] = useState("");
    const [validationError, setValidationError] = useState({
      className: "",
      errorMessage: "",
    });
    const [loadingSpinnerText, setLoadingSpinnerText] = useState("");
    const [sendEmailButtonDisabled, setSendEmailButtonDisabled] = useState(false);

    const updateSelectedOption = (e, data) => {
      setValidationError({ className: "", errorMessage: "" });
      setSelectedOption(data.value);
    };

    const updateSelectedYearOption = (e, data) => {
      setValidationError({ className: "", errorMessage: "" });
      setSelectedYearOption(data.value);
    };

    const getOptions = () =>
      Object.values(qarQuarters).map((x) => ({
        key: x,
        text: `${x}`,
        value: `${x}`,
      }));

    const getYearOptions = () =>
      [new Date().getFullYear() - 1, new Date().getFullYear()].map((x) => ({
        key: x,
        text: `${x}`,
        value: `${x}`,
      }));

    const showModalHandler = () => {
      if (selectedOption !== "" && selectedYearOption !== "") {
        sendMailsConfirmationModal.modalContentDataInPreview = RootStore.qarStore.manualDataForPreview.manualDataInPreview ? "<p style=color:red;>There is imported data that is not reviewed yet and will not be included in the reviews.</p>" : "";
        setShowModal(true);
      } else {
        let error = {
          className: "validation-error-message",
          errorMessage:
            "Please, select the quarter for which mails will be send!",
        };
        setValidationError(error);
      }
    };

    const showSetReviewsCompletedModalHandler = () => {
      setCompletedReviewsShowModal(true);
    };

    const sendMails = () => {
      if (!RootStore.qarStore.isActionTaken) {
        setLoadingSpinnerText("Sending Emails");
        setSendEmailButtonDisabled(true);
        RootStore.qarStore.setIsActionTaken(true);
        RootStore.qarStore.sendSOXEmails(selectedOption, selectedYearOption, RootStore.userStore.currentUserID);
      }
      setShowModal(false);

    };

    const setManagerReviewsCompleted = () => {
      setLoadingSpinnerText("Modifying manager reviews state");

      RootStore.qarStore.setManagerReviewsAsCompleted(RootStore.qarStore.currentQuarter, RootStore.qarStore.currentYear, RootStore.userStore.currentUserID);

      setCompletedReviewsShowModal(false);
    }

    const getAccountsFromGroup = () => {
      let accounts = [];
      if (chameleonAccountGroup.corporateGroups) {
        chameleonAccountGroup.corporateGroups.map(x => {
          accounts.push(x);
        });

      }
      return accounts;
    }

    const systemClickHandler = (system) => {
      getSystemAccounts(system.id);
      setActiveSystemName(system.name);
    };

    const managerReviewCompletedButtonHandler = () => {

      if (RootStore.qarStore.totalManagerReviews !== undefined
        && RootStore.qarStore.totalManagerReviews === RootStore.qarStore.completedManagerReviews
        && RootStore.qarStore.isManagerReviewsCompleted === false
        && (RootStore.userStore.isUserCiso || RootStore.userStore.isUserSoxCompliance)) {
        return false;
      }
      return true;
    }

    const qarSystemsComponents = {
      Body: (props) => {
        let totalObj = {
          totalAccounts: 0,
          completedAccounts: 0,
          totalManagers: RootStore.qarStore.currentlyReviewedSystemForReview.totalManagerReviews,
          completedManagers: RootStore.qarStore.currentlyReviewedSystemForReview.completedManagerReviews
        }

        props.renderData.forEach((rowData) => {
          totalObj.totalAccounts += rowData.totalUserAccounts + rowData.totalUnmatchedAccounts;
          totalObj.completedAccounts += rowData.totalReviewedUserAccounts + rowData.totalReviewedUnmatchedAccounts;
        });

        return (
          <>
            <MTableBody {...props} />
            {props.renderData.length > 0 ? <>
              <TableFooter>
                <TableRow>
                  <TableCell colSpan={2} />
                  <TableCell>{totalObj.completedAccounts}/{totalObj.totalAccounts}</TableCell>
                  <TableCell>{(totalObj.completedAccounts / totalObj.totalAccounts * 100 || 0).toFixed(2)} %</TableCell>
                  <TableCell>{totalObj.completedManagers}/{totalObj.totalManagers}</TableCell>
                  <TableCell>{(totalObj.completedManagers / totalObj.totalManagers * 100 || 0).toFixed(2)} %</TableCell>
                </TableRow>
              </TableFooter>
            </>
              : <></>}
          </>
        )
      }
    }

    const renderQarSystem = () => {
      return <>
        <Tabs
          value={RootStore.qarStore.currentComplianceReviewId}
          onChange={(_, value) => {
            RootStore.qarStore.clearAccountGroups();
            console.log("Account groups emptied.")
            RootStore.qarStore.currentlyReviewedSystemForReview = null;
            RootStore.qarStore.currentComplianceReviewId = value
            return RootStore.qarStore.getAllSystemsForReview(value);
          }}
          className="MuiPaper-rounded quarter" variant="scrollable" scrollButtons="auto"
          style={{ padding: "0px 0px 10px 0px" }}
          TabIndicatorProps={{
            style: {
              backgroundColor: "#4183C4",
            },
          }}
        >
          {RootStore.qarStore.complianceReviews?.map((x) => (
            <Tab
              key={x.managerReviewAdminId} value={x.managerReviewAdminId}
              label={Quarter[x.quarter] + "/" + x.quarterYear}
            />
          ))}
        </Tabs>

        <div id="qar-systems">
          <Card className="systems-card">
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                Systems
                <button onClick={() => exportQarFindingsClickHandler(RootStore.qarStore.currentComplianceReviewId)} style={{ float: "right" }} className="MuiButtonBase-root MuiIconButton-root MuiIconButton-colorInherit" tabIndex="0" type="button" aria-label="Export" title="Export all findings"><span className="MuiIconButton-label"><span className="material-icons MuiIcon-root" aria-hidden="true">save_alt</span></span><span className="MuiTouchRipple-root"></span></button>
              </Typography>
              { RootStore.qarStore.systemsForReview.slice().sort((a, b) =>
                    a.name.toLowerCase().localeCompare(b.name.toLowerCase())).map((system) => (
                <Card
                  key={system.id}
                  className={"system-card "}
                  id={"system-card"}
                >

                  <CardContent>
                    <Typography variant="h5" component="h2">
                      {system.name}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button
                      size="small"
                      onClick={() => systemClickHandler(system)}
                    >
                      VIEW
                    </Button>
                  </CardActions>
                </Card>

              ))}
            </CardContent>
          </Card>
        </div>
        <ConfirmationModal
          content={sendMailsConfirmationModal.modalContent + sendMailsConfirmationModal.modalContentDataInPreview}
          header={sendMailsConfirmationModal.modalHeader}
          submitFunction={sendMails}
          onClose={() => setShowModal(false)}
          show={showModal}
        />
        <ConfirmationModal
          content={setManagerReviewsCompletedConfirmationModal.modalContent}
          header={setManagerReviewsCompletedConfirmationModal.modalHeader}
          submitFunction={setManagerReviewsCompleted}
          onClose={() => setCompletedReviewsShowModal(false)}
          show={showCompletedReviewsModal}
        />
        {RootStore.qarStore.currentlyReviewedSystemForReview ?
          <Typography variant="h6" component="h6" align="center">
            <h4>{new Date(RootStore.qarStore.creationDate).toUTCString()}</h4>
            ({new Date(RootStore.qarStore.creationDate).toLocaleString()} local time)
            <HtmlTooltip
              title={
                <React.Fragment>
                  <Typography color="inherit" variant="caption">
                    This is the compliance review creation date.
                  </Typography>
                </React.Fragment>
              }
            >
              <IconButton aria-label="delete" size="small">
                <HelpOutlineIcon fontSize="inherit" />
              </IconButton>
            </HtmlTooltip>
          </Typography> : <></>}
        <div id="system-accounts">
          {RootStore.qarStore.currentlyReviewedSystemForReview ? (
            RootStore.qarStore.currentlyReviewedSystemForReview.name === 'Chameleon' ? (
              chameleonAccountGroup ? (
                <MaterialTable
                  title=''
                  data={getAccountsFromGroup()}
                  columns={qarSystemsColumns}
                  options={qarSystemsTableOptions}
                  onRowClick={clickHandler}
                  actions={[
                    (rowData) => ({
                      icon: "chevron_right",
                      tooltip: "View more",
                    }),
                  ]}
                  localization={{
                    toolbar: {
                      exportCSVName: "Export as XLSX",
                    },
                    header: {
                      actions: "",
                    },
                  }}
                  components={qarSystemsComponents}
                />) : (
                <MaterialTable
                  title=''
                  data={RootStore.qarStore.chameleonGroups}
                  columns={qarAccountGroupsColumns}
                  options={qarSystemsTableOptions}
                  onRowClick={accountGroupsClickHadler}
                  actions={[
                    (rowData) => ({
                      icon: "chevron_right",
                      tooltip: "View more",
                    }),
                  ]}
                  localization={{

                    header: {
                      actions: "",
                    },
                  }}

                />
              )) : (
              <MaterialTable
                title=''
                data={RootStore.qarStore.currentlyReviewedSystemForReview.accounts}
                columns={qarSystemsColumns}
                options={qarSystemsTableOptions}
                onRowClick={clickHandler}
                actions={[
                  (rowData) => ({
                    icon: "chevron_right",
                    tooltip: "View more",
                  }),
                ]}
                localization={{
                  toolbar: {
                    exportCSVName: "Export as XLSX",
                  },
                  header: {
                    actions: "",
                  },
                }}
                components={qarSystemsComponents}
              />
            )

          ) : (
            ""
          )}
          <div className="floated-right-content">
            <Typography align="center" color="textSecondary">
              {isValidDate(RootStore.qarStore.lastNotificationDate)
                ? `Last notification was sent on ${new Date(
                  RootStore.qarStore.lastNotificationDate
                ).toUTCString()}`
                : ""}
            </Typography>
            <Dropdown
              placeholder="Select desired year"
              selection
              value={selectedYearOption}
              options={getYearOptions()}
              onChange={(e, data) => updateSelectedYearOption(e, data)}
            />
            <Dropdown
              placeholder="Select desired quarter"
              selection
              value={selectedOption}
              options={getOptions()}
              onChange={(e, data) => updateSelectedOption(e, data)}
            />
            <button
              className="btn btn-primary"
              id="mail-sender-button"
              disabled={sendEmailButtonDisabled}
              onClick={showModalHandler}
            >
              Send Emails
            </button>
            <p className={validationError.className}>
              {validationError.errorMessage}
            </p>
          </div>
          <div id="complete-reviews-div">
            <button
              className="btn btn-primary"
              id="complete-reviews-button"
              disabled={managerReviewCompletedButtonHandler()}
              onClick={showSetReviewsCompletedModalHandler}
            >
              Mark manager reviews as completed
            </button>
          </div>
        </div>
      </>
    };

    const renderAllUnmatchedAccounts = () => {
      return <QarAllUnmatchedAccounts />;
    }

    const renderTableContent = () => {
      switch (activeItem) {
        case qarAdminNavListItems.qarSystems:
          return renderQarSystem();
        case qarAdminNavListItems.notRecognizedAccounts:
          return renderAllUnmatchedAccounts();
        case qarAdminNavListItems.manualDataUpload:
          return <QarManualData />;
        default:
          return <></>;
      }
    };

    return (
      <>
        {RootStore.qarStore.showLoadingSpinner ? (
          <LoadingSpinner text={loadingSpinnerText} />
        ) : RootStore.qarStore.currentlySelectedAccountForReview ? (
          <QarManagers activeSystemName={activeSystemName} />
        ) : (
          <>
            <div className="dropdown">
              <div className="dropdown-menu show">
                <List>
                  {Object.values(qarAdminNavListItems).map((text) => (
                    <ListItem className='nav-link nav-item' key={text} disablePadding>
                      <ListItemButton selected={activeItem===text} onClick={() => setActiveItem(text)}>
                        <ListItemText primary={text} />
                      </ListItemButton>
                    </ListItem>
                  ))}
                </List>
              </div>
            </div>
            <div id="qar-systems-panel">
              {renderTableContent()}
            </div>
          </>
        )}
        <div>
          <ModalWrapper></ModalWrapper>
        </div>
      </>
    );
  })
);

export default QarSystems;
